<script lang="ts" module>
	export interface TableHeaderRowProps {
		dataCy: string;
		children?: import('svelte').Snippet;
		class?: string;
	}
</script>

<script lang="ts">
	import { twMerge } from 'tailwind-merge';

	let { dataCy, children, ...rest }: TableHeaderRowProps = $props();
</script>

<thead data-cy={`${dataCy}-header-row`}>
	<tr class={twMerge('rounded-t border-x border-gray-200', rest.class)}>
		{@render children?.()}
	</tr>
</thead>
